// The thumbnail of a file in the list and the gallery (um/2026-10-30/03 п.8): the server's WebP of a picture, else — and when the
// server has none (too large, broken) — the icon of the file's kind. Thumbnails load lazily as they come into view.

import { useState } from 'react';
import { Icon } from '../ui/icons.tsx';
import { cx } from '../ui/primitives.tsx';
import { KIND_ICON, kindOf } from './kinds.ts';
import s from './files.module.css';

export function FileThumb({ fileKey, type, name, size = 'sm' }: { fileKey: string; type: string; name: string; size?: 'sm' | 'lg' }) {
  const kind = kindOf(type, name);
  const [failed, setFailed] = useState(false);
  return (
    <span className={cx(s.thumb, size === 'lg' && s.thumbLg)} data-kind={kind} aria-hidden>
      {kind === 'image' && !failed
        ? <img src={`/api/files-thumb/${fileKey}`} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />
        : <Icon name={KIND_ICON[kind]} size={size === 'lg' ? 32 : 16} />}
    </span>
  );
}
